import * as React from 'react';

// tslint:disable-next-line:max-line-length
class Container extends React.Component<
  React.DetailedHTMLProps<
    React.HtmlHTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >
> {
  // Adding a property to add external css class. 
  containerClassName?: string;

  constructor(
    props: React.DetailedHTMLProps<
      React.HtmlHTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >
  ) {
    super(props);
  }

  render() {

    // Check if external css properties comes from parent
    let containerUserClass = this.containerClassName === null ? '' : this.containerClassName;
    
    return (
      <div {...this.props} className={`container ${this.props.className} ${containerUserClass}`}>
        {this.props.children}
      </div>
    );
  }
}

export default Container;



// WEBPACK FOOTER //
// ./src/Components/Container.tsx